const DEFAULT_SITE_URL = 'https://www.fixome.in';

/**
 * Public meta tags always use https://www.fixome.in.
 * The apex host redirects to www. Preview builds set REACT_APP_SITE_URL to a
 * vercel.app host; using that host for og:image makes the prerender exit.
 */
export function resolveSiteUrl() {
  return DEFAULT_SITE_URL;
}

export const BUSINESS_ID = `${DEFAULT_SITE_URL}/#business`;

/**
 * Self-canonical URL on https://www.fixome.in with no trailing slash.
 * The homepage is the origin itself (`https://www.fixome.in`).
 */
export function publicCanonical(path) {
  const value = String(path || '/').trim();
  let pathname = value;
  if (value.startsWith('http://') || value.startsWith('https://')) {
    pathname = new URL(value).pathname;
  }
  pathname = pathname.split('?')[0].split('#')[0];
  if (!pathname.startsWith('/')) pathname = `/${pathname}`;
  pathname = pathname.replace(/\/+$/, '');
  return `${DEFAULT_SITE_URL}${pathname}`;
}

export { DEFAULT_SITE_URL };
